<template>
    <div>
        <div style=" margin: 0 0 20px 0; position: relative; height: 60px">
            <button @click="addNewResource" class="btn btn-info" v-if="isUserSysOp" style="position: absolute; right: 0px; top: 20px">Add New Resource</button>
            <div class="form-group" style="position: absolute; left: 0;">
                <label for="frm-name">Filter by Name</label>
                <input type="text" v-model="nameFilter" class="form-control" style="display: inline-block" />
            </div>
        </div>
        <div v-if="statusMessage" :class="['alert', 'alert-dismissible', (statusMessage.type == 'error') ? 'alert-danger' : 'alert-info']">
            <span class="close" aria-label="close" v-on:click="statusMessage = null">&times;</span>
            <p v-text="statusMessage.text"></p>
        </div>
        <div style="position: relative">
            <table v-if="resourcesDictionaryLocal" class="table table-striped table-hover">
                <tbody>
                <tr class="table-header">
                    <th>Name</th>
                    <th>Type</th>
                    <th width="50%">Content</th>
                    <th width="100px"></th>
                </tr>
                <tr v-for="resource in resourcesDictionaryLocal" :key="resource.key">
                    <td>{{resource.key}}</td>
                    <td>{{typeToText(resource.type)}}</td>
                    <td v-if="resource.type == 'text'">{{resource.value}}</td>
                    <td v-if="resource.type == 'multi-text'">
                        <div style="max-height: 150px; overflow-y: auto">
                            <div v-for="(text, index) in resource.value" :class="{'multi-text-separator' : index < resource.value.length - 1}">
                                <span v-text="text.substring(0, 70)"></span>
                                <span v-if="text.length > 70">...</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <span class="fas fa-pencil btn" v-on:click="onResourceEdit(resource)" style="display: inline-block"></span>
                        <span class="fas fa-trash btn" v-if="isUserSysOp" @click="onDelete(resource.key)" style="display: inline-block"></span>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-show="isBusy" class="loader-overlay">
                <div class="loader"></div>
            </div>
        </div>
        <resources-dictionary-edit-modal :value="resourceToEdit" v-show="isEditModalOpen" :add-update-url="addUpdateUrl"
                                         @cancel="isEditModalOpen = false" @save="onSaveResource" :is-user-sys-op="isUserSysOp">

        </resources-dictionary-edit-modal>
    </div>
</template>

<script>
    export default {
        props:{
            addUpdateUrl: String,
            deleteUrl: String,
            resourcesDictionary: Array,
            isUserSysOp: Boolean
        },
        name: "resources-dictionary-page",
        data() {
            return {
                tipModel: null,
                resourcesDictionaryLocalAll: [],
                resourcesDictionaryLocal: [],
                statusMessage: null,
                isBusy: false,
                isAddVisible: false,
                isEditModalOpen: false,
                resourceToEdit: null,
                nameFilter: '',
                treeData: []
            };
        },
        methods:{
            onSaveResource(response){
                console.log(response);
                let isAdding = true;
                this.resourcesDictionaryLocalAll = _.map(this.resourcesDictionaryLocalAll, (t) => {
                    if (t.key === response.prevKey) {
                        isAdding = false;
                        return response.item;
                    }
                    return t;
                });

                if (isAdding) {
                    this.resourcesDictionaryLocalAll.push(response.item);
                }

                this.filterByName();
                this.isEditModalOpen = false;
                this.resourceToEdit = null;
            },
            typeToText(type){
                switch (type) {
                    case 'text' :
                        return 'Text';
                    case 'multi-text' :
                        return 'Multi Text';
                }
            },
            onDelete(key){
                this.isBusy = true;
                axios.post(this.deleteUrl, {key})
                    .then((response) => {
                        this.statusMessage = null;
                        this.showInfo('Item removed.');
                        _.remove(this.resourcesDictionaryLocalAll, (item) => item.key == key);
                        this.filterByName();
                    })
                    .catch(() => {
                        this.showError('We cannot delete item, please try again later.');
                    })
                    .finally(()=> {
                        this.isBusy = false;
                    });
            },
            addNewResource(){
                this.isEditModalOpen = true;
                this.resourceToEdit = {};
                this.statusMessage = null;
                this.statusMessag = null;
            },
            onResourceEdit(resource){
                this.isEditModalOpen = true;
                this.resourceToEdit = _.cloneDeep(resource);
                this.statusMessag = null;
            },
            showError(message){
                this.statusMessage = {
                    type: 'error',
                    text: message
                }
            },
            showInfo(message){
                this.statusMessage = {
                    type: 'info',
                    text: message
                }
            },
            filterByName(){
                this.resourcesDictionaryLocal = _.filter(this.resourcesDictionaryLocalAll, (item) => { return item.key.includes(this.nameFilter);});
            },
            // makeTreeData(name, data, r){
            //     if(!name.includes('.')){
            //         if(!data[name]){
            //             data[name] = {
            //                 name: name,
            //                 data: []
            //             };
            //         }
            //         data[name].data.push(r);
            //         return;
            //     }
            //     var subName = name.split('.', 1)[0];
            //     name = name.substring(subName.length + 1);
            //     if(!data[subName]){
            //         data[subName] = {
            //             name: subName,
            //             data: []
            //         };
            //     }
            //     this.makeTreeData(name, data[subName], r);
            // }
        },
        watch: {
            nameFilter(){
                this.filterByName();
            }
        },
        mounted() {
            this.resourcesDictionaryLocal = _.cloneDeep(this.resourcesDictionary);
            this.resourcesDictionaryLocalAll = _.cloneDeep(this.resourcesDictionary);
            // _.forEach(this.resourcesDictionaryLocal, (r) => {
            //     this.makeTreeData(r.name, this.treeData, r)
            // });
        }
    }
</script>

<style scoped>

    .loader-overlay{
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 99999999;
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }
    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -2.2em;
        margin-left: -2.2em;
    }

    .multi-text-separator {
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid lightgray;
    }
</style>